<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if (this.$isWeiXin()) {
      this.$wxShare()
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC',
  'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  min-height: 100vh;
  background: url('~@/assets/images/app-bg.png') repeat-y;
  /* background: url('~@/assets/images/app-bg.webp') repeat-y; */
  background-size: 100%;
  max-width: 750px;
  position: relative;
  /* overflow: hidden; */
  height: auto;
  font-size: 14px;
}
</style>
